export function UserFailed() {
  return (
    <div className='flex h-75 w-full items-center justify-center'>
      <h2>Request access to the system from your administrator (DevOps)</h2>
    </div>
  )
}
